import { NavigoIconButton } from '@/components/Navigo/elements/NavigoIconButton'
import { ReadOnlyTooltip } from '@/components/smartUtils/plan/ReadOnlyTooltip'
import { Edit } from '@/icons'

import { useTexts } from '../useTexts'

interface Props {
  onClick: () => void
  disabled: boolean
}

export function EditButton(props: Props) {
  const { disabled, onClick } = props
  const texts = useTexts()

  return (
    <ReadOnlyTooltip
      render={preventEditing => (
        <NavigoIconButton
          text={texts.edit}
          onClick={onClick}
          disabled={disabled || preventEditing}
          testid="navigo-routes-overview-actions-edit"
          Icon={<Edit color={disabled || preventEditing ? '$silver' : '$nightRider'} size={17} />}
        />
      )}
    />
  )
}
